export default __webpack_public_path__ + "static/media/Left arrow (3).8cc68a1a.svg";